webpackJsonp([18],{

/***/ "0Flw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./src/store/index.js
var store = __webpack_require__("IcnI");

// EXTERNAL MODULE: ./src/router/index.js + 1 modules
var router = __webpack_require__("YaEn");

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ./src/config/env.js
var env = __webpack_require__("uaSg");

// EXTERNAL MODULE: ./node_modules/mini-toastr/mini-toastr.js
var mini_toastr = __webpack_require__("EMpD");

// CONCATENATED MODULE: ./src/thirdparty/options.js
// v-server-table default options
var serverTableOptions = {
    texts: {
        count: "Affiche {to} des {count} contenus | {count} contenus | un contenu",
        filter: "",
        filterPlaceholder: "Recherchez ici",
        limit: "Fiches:",
        page: "Page:",
        noResults: "Aucune fiche trouvée",
        filterBy: "Filtre par {column}",
        loading: 'Chargement...',
        defaultOption: 'Selectionner {column}'
    }
};

// mini-toastr config
var toastrOptions = {
    timeout: 4000
};
// CONCATENATED MODULE: ./src/services/base.service.js








var client = axios_default.a.create({
    baseURL: env["a" /* API_URL */],
    withCredentials: true,
    responseType: 'json',
    headers: { 'Content-Type': 'multipart/form-data' }
});

/* harmony default export */ var base_service = ({
    execute: function execute(method, resource, data) {
        var _this = this;

        return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
            return regenerator_default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            return _context.abrupt('return', client({
                                method: method,
                                url: resource,
                                data: data
                            }).then(function (response) {
                                //console.log("base.service.js GLOBAL LOG ajax query method:" + method + " url:" + resource);
                                //console.log('base.service.js GLOBAL response data log', response.data);
                                return response.data;
                            }).catch(function (error) {
                                // handle error
                                console.log(error);
                                console.log(_this);

                                mini_toastr["a" /* default */].init(toastrOptions);
                                mini_toastr["a" /* default */].error("Une erreur est survenue, merci de patienter ou de contacter le responsable du site :" + error);
                            }));

                        case 1:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    },

    // AUTH methods
    checkLoggin: function checkLoggin(data) {
        return this.execute('post', '/UserSession/login', data);
    },
    checkUser: function checkUser() {
        return this.execute('get', '/UserSession/currentUser');
    },

    // default service methods
    get: function get(resource, option) {
        return this.execute('get', '' + resource, option);
    },
    post: function post(resource, data) {
        return this.execute('post', '' + resource, data);
    }
});
// EXTERNAL MODULE: ./node_modules/vue-meta/dist/vue-meta.esm.js
var vue_meta_esm = __webpack_require__("f3bp");

// EXTERNAL MODULE: ./node_modules/bootstrap/dist/css/bootstrap.css
var bootstrap = __webpack_require__("Jmt5");
var bootstrap_default = /*#__PURE__*/__webpack_require__.n(bootstrap);

// EXTERNAL MODULE: ./node_modules/bootstrap-vue/dist/bootstrap-vue.css
var bootstrap_vue = __webpack_require__("9M+g");
var bootstrap_vue_default = /*#__PURE__*/__webpack_require__.n(bootstrap_vue);

// CONCATENATED MODULE: ./src/mixins/auth.js
/* harmony default export */ var auth = ({
    methods: {
        $checkAuth: function $checkAuth() {
            var _this = this;

            console.log("checkAuth:" + this.$store.state.isLoggedIn);
            if (this.$store.state.isLoggedIn) return;
            this.$AJAX.checkUser().then(function (data) {
                setAuthRoutes(_this, data);
            });
        },
        $logCredentials: function $logCredentials(creds) {
            var _this2 = this;

            console.log("logCredientials");
            if (this.$store.state.isLoggedIn) return;

            this.$AJAX.checkLoggin(creds).then(function (data) {
                //-- 100 is for logging, valid is for currentUser query at each route
                if (data.code === '100' || data.status === 'valid') {
                    setAuthRoutes(_this2, data);
                    _this2.$router.push(_this2.$store.state.appRootPath);
                } else _this2.$processDataMsg(data);
            });
        }
    }
});

function setAuthRoutes(Vue, data) {
    if (data.code === '100' || data.status === 'valid') {
        Vue.$store.dispatch('login', data);
        //Vue.$router.push(Vue.$store.state.appRootPath);
        //-- Loading dyn-contents for the user
        //if (!Vue.$store.state.isDynContentLoaded)
        //Vue.$loadDynContent();    
    } else {
        Vue.$processDataMsg(data);
        return Vue.$router.push('/login');
    }
}
// CONCATENATED MODULE: ./src/mixins/ui.js

/* harmony default export */ var ui = ({
    methods: {
        $closeDetailBox: function $closeDetailBox() {
            this.showDetail = false;
        }
    }
});
// EXTERNAL MODULE: ./src/mixins/helpers.js
var helpers = __webpack_require__("MNMD");

// CONCATENATED MODULE: ./src/mixins/dyncontent-templates.js
/* harmony default export */ var dyncontent_templates = ({
    methods: {
        $selectContentLabel: function $selectContentLabel(page, label) {
            var formLabels = this.$templateDefault();
            if (this.$checkNull(page)) {
                switch (page) {
                    case 'select_category_blog':
                    case 'select_category_news':
                        formLabels = {
                            protected: [],
                            flag1: '-1',
                            text: 'Description',
                            text2: '-1',
                            text2En: '-1',
                            image: '-1',
                            order: 'Ordre'
                        };
                        break;
                    case 'select_category_project':
                        formLabels = {
                            protected: [],
                            flag1: '-1',
                            text: 'Description',
                            text2: 'Catégorie',
                            text2En: '-1',
                            image: '-1',
                            order: 'Ordre'
                        };
                        break;
                    case 'select_heading_project':
                        formLabels = {
                            protected: [],
                            flag1: '-1',
                            text: 'Description',
                            text2: '-1',
                            text2En: '-1',
                            image: '-1',
                            order: 'Ordre'
                        };
                        break;
                    case 'navigation':
                        formLabels = {
                            protected: ['page', 'label'],
                            flag1: '-1',
                            text: 'Label navigation',
                            text2En: '-1',
                            text2: '-1',
                            image: '-1',
                            order: '-1'
                        };
                        break;
                    case 'slider_home':
                        formLabels = {
                            protected: [],
                            flag1: 'Texte description bas',
                            text: 'Label navigation',
                            text2: '-1',
                            text2En: '-1',
                            order: 'Ordre',
                            text3: 'Description slider',
                            image: '-'
                        };
                        break;
                    case 'studio':
                    case 'contact':
                        switch (label) {
                            case 'image_droite':
                                formLabels = this.$templateImage();
                                break;
                            default:
                                if (label.match(/^meta\_/g)) formLabels = this.$templateMeta();else formLabels = this.$templateShortContent();
                                break;
                        }
                        break;
                    case 'newsroom':
                        if (label.match(/^meta\_/g)) formLabels = this.$templateMeta();else formLabels = this.$templateContent();
                        break;
                    default:
                        if (label.match(/^meta\_/g) || label == "description_filtre") formLabels = this.$templateMeta();
                        break;
                }
            }
            return formLabels;
        },
        $templateDefault: function $templateDefault() {
            return {
                protected: [],
                flag1: 'flag 1',
                text: 'Texte',
                text2: 'Texte 2 FR',
                text2En: 'Texte 2 EN',
                order: 'Ordre'
            };
        },
        $templateImage: function $templateImage() {
            return {
                protected: ['page', 'label', 'no_html'],
                flag1: '-1',
                text: '-1',
                text2: '-1',
                text2En: '-1',
                image: '-',
                order: '-1'
            };
        },
        $templateMeta: function $templateMeta() {
            return {
                protected: ['page', 'label', 'no_html'],
                flag1: '-1',
                text: 'Description',
                text2: '-1',
                text2En: '-1',
                image: '-1',
                order: '-1'
            };
        },
        $templateContent: function $templateContent() {
            return {
                protected: ['page', 'label'],
                flag1: '-1',
                text: 'Description',
                text2: 'Titre  FR',
                text2En: 'Titre EN',
                image: '-1',
                order: '-1'
            };
        },
        $templateShortContent: function $templateShortContent() {
            return {
                protected: ['page', 'label'],
                flag1: '-1',
                text: 'Description',
                text2: '-1',
                text2En: '-1',
                image: '-1',
                order: '-1'
            };
        }
    }
});
// CONCATENATED MODULE: ./src/mixins/index.js






//import dynContents from './dyn-contents';

vue_esm["default"].mixin(auth);
vue_esm["default"].mixin(ui);
vue_esm["default"].mixin(helpers["b" /* default */]);
vue_esm["default"].mixin(dyncontent_templates);
//Vue.mixin(dynContents);
// EXTERNAL MODULE: ./node_modules/bootstrap-vue/esm/index.js + 295 modules
var esm = __webpack_require__("Tqaz");

// EXTERNAL MODULE: ./node_modules/vue-select/dist/vue-select.js
var vue_select = __webpack_require__("T1ft");
var vue_select_default = /*#__PURE__*/__webpack_require__.n(vue_select);

// EXTERNAL MODULE: ./node_modules/vue-tables-2/compiled/index.js
var compiled = __webpack_require__("e9ss");
var compiled_default = /*#__PURE__*/__webpack_require__.n(compiled);

// CONCATENATED MODULE: ./src/thirdparty/index.js







// Notification messages initialization
var notification = {
    install: function install(Vue, options) {
        Vue.prototype.$Notification = mini_toastr["a" /* default */].init(toastrOptions);
    }
};

var mods = [{ modName: esm["a" /* default */] }, { modName: compiled["ServerTable"], option: serverTableOptions }, { modName: notification }];

var components = [{ name: vue_select_default.a, id: 'v-select' }];

mods.forEach(function (mod) {
    return vue_esm["default"].use(mod.modName, mod.option ? mod.option : null);
});
components.forEach(function (component) {
    return vue_esm["default"].component(component.id, component.name);
});
// EXTERNAL MODULE: ./src/scss/core.scss
var core = __webpack_require__("8Eth");
var core_default = /*#__PURE__*/__webpack_require__.n(core);

// EXTERNAL MODULE: ./node_modules/font-awesome/css/font-awesome.min.css
var font_awesome_min = __webpack_require__("e0XP");
var font_awesome_min_default = /*#__PURE__*/__webpack_require__.n(font_awesome_min);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/layout/Index.vue
//
//
//
//


/* harmony default export */ var Index = ({
    name: 'AppLayout',
    components: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d301e0a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layout/Index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var layout_Index = (esExports);
// CONCATENATED MODULE: ./src/layout/Index.vue
function injectStyle (ssrContext) {
  __webpack_require__("GXu7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6d301e0a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Index,
  layout_Index,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_layout_Index = (Component.exports);

// CONCATENATED MODULE: ./src/app.init.js





//-- Meta rewriting


vue_esm["default"].use(vue_meta_esm["a" /* default */], {
    // optional pluginOptions
    refreshOnceOnNavigation: true
});

//-- Basic bootstrap



//import 'font-awesome/css/font-awesome.min.css';




//-- Import font-awesome css for the tables icons vue-table




vue_esm["default"].config.productionTip = false;

var API = {
    install: function install(Vue, options) {
        Vue.prototype.$AJAX = base_service;
    }
};

vue_esm["default"].use(API);

(function () {
    return new vue_esm["default"]({
        name: 'Root',
        template: '<AppLayout />',
        components: {
            AppLayout: src_layout_Index
        },
        el: '#app',
        router: router["a" /* default */],
        store: store["a" /* default */],
        mounted: function mounted() {
            var _this = this;

            //console.log(router)
            router["a" /* default */].beforeEach(function (to, from, next) {
                //-- Rewrite title for admin               
                if (to.meta.front === false) _this.$updatePageTitle(to, from, next);
                next();
            });

            router["a" /* default */].afterEach(function (to, from, next) {
                //console.log("ROUTER!!"+to.meta);
                if (to.meta.auth === true) {
                    //console.log(to.meta);
                    _this.$checkAuth();
                }
                if (to.meta.front === true) {
                    //-- Check menu expanded or collapsed
                    _this.$store.state.menuFrontExpanded = to.meta.menu;
                    //--Check if a specific language is asked
                    if (_this.$checkNull(_this.$route.params.getLng)) _this.$store.state.lngFront = _this.$route.params.getLng;

                    //-- Add lang in url (for copy/paste)
                    _this.$nextTick(function () {
                        //console.log("rewrite url" + this.$route.path);
                        //this.$changeLngUrl();
                    });
                }
            });

            //-- Adding header for xht USED FOR uploading the images / files
            XMLHttpRequest.prototype.origOpen = XMLHttpRequest.prototype.open;
            XMLHttpRequest.prototype.open = function () {
                this.origOpen.apply(this, arguments);
                //this.setRequestHeader('X-TOKEN', 'the token');
                this.withCredentials = true;
            };

            //-- Clearing array izi
            Array.prototype.clear = function () {
                while (this.length > 0) {
                    this.pop();
                } // Fastest
            };

            //-- Used to compare date in an array (find doesn't work)
            Array.prototype.indexOfDate = function (date) {
                for (var i = 0; i < this.length; i++) {
                    if (+this[i] === +date) return i;
                };
                return -1;
            };
        }
    });
})();

/***/ }),

/***/ "2Qfd":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI0LjEuMiwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkNhbHF1ZV8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIKCSB2aWV3Qm94PSIwIDAgNDIuNSA0MS4xIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA0Mi41IDQxLjE7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDojRkZGRkZGO30KPC9zdHlsZT4KPGc+Cgk8cGF0aCBjbGFzcz0ic3QwIiBkPSJNMS40LDIwLjVjMCwxLjEsMC45LDIsMiwyaDMxTDIxLjksMzVjLTAuOCwwLjgtMC44LDIsMCwyLjhjMC44LDAuOCwyLDAuOCwyLjgsMGwwLDBsMTUuOS0xNS45CgkJYzAuMS0wLjEsMC4yLTAuMiwwLjItMC4zdi0wLjFsMC4xLTAuM3YtMC4xYzAtMC4xLDAuMS0wLjIsMC4xLTAuM2MwLTAuMSwwLTAuMywwLTAuNGMwLTAuMSwwLTAuMywwLTAuNGMwLTAuMSwwLTAuMi0wLjEtMC4ydi0wLjEKCQlsLTAuMS0wLjN2LTAuMWwtMC4yLTAuM0wyNC44LDMuMmMtMC44LTAuOC0yLTAuOC0yLjgsMGMtMC44LDAuOC0wLjgsMiwwLDIuOGwxMi41LDEyLjVoLTMxQzIuMywxOC41LDEuNCwxOS40LDEuNCwyMC41eiIvPgo8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ "8Eth":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9M+g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AfEf":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI0LjEuMiwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkNhbHF1ZV8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIKCSB2aWV3Qm94PSIwIDAgNDIuNSA0MS4xIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA0Mi41IDQxLjE7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDojMDA2NzZDO30KPC9zdHlsZT4KPGc+Cgk8cGF0aCBjbGFzcz0ic3QwIiBkPSJNMS40LDIwLjVjMCwxLjEsMC45LDIsMiwyaDMxTDIxLjksMzVjLTAuOCwwLjgtMC44LDIsMCwyLjhjMC44LDAuOCwyLDAuOCwyLjgsMGwwLDBsMTUuOS0xNS45CgkJYzAuMS0wLjEsMC4yLTAuMiwwLjItMC4zdi0wLjFsMC4xLTAuM3YtMC4xYzAtMC4xLDAuMS0wLjIsMC4xLTAuM2MwLTAuMSwwLTAuMywwLTAuNGMwLTAuMSwwLTAuMywwLTAuNGMwLTAuMSwwLTAuMi0wLjEtMC4ydi0wLjEKCQlsLTAuMS0wLjN2LTAuMWwtMC4yLTAuM0wyNC44LDMuMmMtMC44LTAuOC0yLTAuOC0yLjgsMGMtMC44LDAuOC0wLjgsMiwwLDIuOGwxMi41LDEyLjVoLTMxQzIuMywxOC41LDEuNCwxOS40LDEuNCwyMC41eiIvPgo8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ "GXu7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");


var _mutations;




//import modules from './modules';

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);

var LOGIN_SUCCESS = 'LOGIN_SUCCESS';
var LOGOUT = 'LOGOUT';
var SET_ROLE = 'SET_ROLE';
var DYN_CON_DONE = 'DYN_CON_DONE';
var DYN_CONTENT_LOADED = 'DYN_CONTENT_LOADED';

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
    state: {
        lngFront: 'fr',
        menuFrontExpanded: false,
        contents: [],
        selects: [],
        isDynContentLoaded: false,
        isLoggedIn: false,
        window: { width: '' },
        userRole: null,
        appRootPath: null,
        UserLogin: null,
        navProjects: { cat: '', heading: '', active: false }
    },
    getters: {
        getWindowSize: function getWindowSize(state) {
            return state.window;
        },
        getUserRole: function getUserRole(state) {
            return state.userRole;
        },
        getContents: function getContents(state) {
            return state.contents;
        },
        isDynContLoaded: function isDynContLoaded(state) {
            return state.isDynContentLoaded;
        },
        currentLng: function currentLng(state) {
            return state.lngFront;
        }
    },
    mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, DYN_CONTENT_LOADED, function (state) {
        state.isDynContentLoaded = true;
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, LOGIN_SUCCESS, function (state, login) {
        state.isLoggedIn = true;
        state.UserLogin = login;
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, SET_ROLE, function (state, userRight) {
        switch (userRight) {
            /*
            case 'admin':
                state.userRole = 'admin';
                state.appRootPath = '/admin/dashboard';
                state.isAdmin = true;
                break;*/
            default:
                state.userRole = 'admin';
                state.appRootPath = '/admin/dashboard';
                //state.isAdmin = true;
                break;
        }
        return state.userRole;
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, LOGOUT, function (state) {
        state.isLoggedIn = false;
        state.userRole = null;
        state.appRootPath = '/';
        state.isAdmin = false;
    }), _mutations),
    actions: {
        login: function login(_ref, creds) {
            var state = _ref.state,
                commit = _ref.commit;

            //console.log("actions: login");
            commit(LOGIN_SUCCESS, creds.login);
            commit(SET_ROLE, creds.user_right);
            // FIXME: transform this into a promise for more control
            // return new Promise(resolve => {
            //   resolve();
            // });
        },
        logout: function logout(_ref2) {
            var state = _ref2.state,
                commit = _ref2.commit;

            commit(LOGOUT);
        },
        dynContentLoaded: function dynContentLoaded(_ref3) {
            var state = _ref3.state,
                commit = _ref3.commit;

            commit(DYN_CONTENT_LOADED);
        }
        //modules
    } }));

/***/ }),

/***/ "Jmt5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MNMD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = debounce;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_env__ = __webpack_require__("uaSg");


function debounce(fn, delay) {
    var timeoutID = null;
    return function () {
        clearTimeout(timeoutID);
        var args = arguments;
        var that = this;

        timeoutID = setTimeout(function () {
            fn.apply(that, args);
        }, delay);
    };
}

/* harmony default export */ __webpack_exports__["b"] = ({
    methods: {
        $updatePageTitle: function $updatePageTitle(to, from) {
            var pageTitle = to.matched.find(function (item) {
                return item.meta.title;
            });
            pageTitle ? window.document.title = pageTitle.meta.title : window.document.title = __WEBPACK_IMPORTED_MODULE_0__config_env__["c" /* DOMAIN_TITLE */];
        },
        $scrollToTop: function $scrollToTop() {
            window.scrollTo(0, 0);
        },
        $tomorrowDate: function $tomorrowDate() {
            var today = new Date();
            var tomorrow = new Date();
            tomorrow.setDate(today.getDate() + 1);
            return tomorrow;
        },
        $getNavItem: function $getNavItem(value) {
            return this.$getItemFromContents("navigation", value).text;
        },
        $getItemFromContents: function $getItemFromContents(contentId, itemName, customLng) {
            var contents = this.$store.state.contents[contentId];
            var lng = !customLng ? this.$getLng() : customLng;
            //console.log("getItemFromContents =>" + contentId + " -> " + itemName + " " + contents.length + ' => ' + lng);

            if (this.$checkNull(contents)) {
                var res = contents.find(function (item) {
                    return item.label == itemName;
                });
                if (this.$checkNull(res)) {
                    res[lng]['images'] = res.images;
                    return res[lng];
                }
                console.log(itemName + " doesn't exist");
                return false;
            } else {
                console.log("contents empty for " + contentId + " => " + itemName);
                return false;
            }
        },
        $getMetaTag: function $getMetaTag(page) {
            return {
                title: this.$getItemFromContents(page, "meta_titre").text,
                //titleTemplate: '%s - Yay!',
                htmlAttrs: {
                    lang: this.$getLng(),
                    amp: false
                },
                meta: [{ name: 'description', content: this.$getItemFromContents(page, "meta_description").text }]
            };
        },

        /*
        $validityCheck(context) {
            setInterval(() => {
                if (context.formstate.$invalid) {
                    context.requiredMsg = 'Remplissez les champs requis SVP';
                    context.disabled = true;
                } else {
                    context.requiredMsg = '';
                    context.disabled = false;
                }
            }, 1000)
        },*/
        $checkNull: function $checkNull(value) {
            if (value === '' || value === false || value === null || value === 'undefined' || value === undefined) {
                return false;
            }
            return true;
        },
        $checkMobileFormat: function $checkMobileFormat() {
            if (this.$store.getters.getWindowSize.width < 768) return true;
            return false;
        },
        $toggleCurrentLanguage: function $toggleCurrentLanguage() {
            this.$store.state.lngFront = this.$store.state.lngFront == 'fr' ? this.$store.state.lngFront = 'en' : this.$store.state.lngFront = 'fr';
            this.$changeLngUrl();
            //this.$route.params.extLng = this.$store.state.lngFront;
        },
        $goTo: function $goTo(path) {
            return '/' + this.$getLng() + '/' + path;
        },
        $changeLngUrl: function $changeLngUrl() {
            var uri = this.$getLng() == "fr" ? "1" : "2";
            var supp = "?" + uri + this.$route.path.charAt(1) + "#";

            if (this.$route.path == "/") history.pushState({}, null, supp + "/" + this.$getLng());else history.pushState({}, null, supp + this.$route.path.replace(/\/(fr|en)$/g, '') + "/" + this.$getLng());
        },
        $getLng: function $getLng() {
            return this.$store.getters.currentLng;
        },
        $checkSearchString: function $checkSearchString(searchValue) {
            //-- replace invalid chars
            searchValue = searchValue.replace(/[^a-zA-Z0-9éàèê ]/g, '');
            if (!this.$checkNull(searchValue) || searchValue.length < 3) return false;else return searchValue;
        },
        $selectFilterHeading: function $selectFilterHeading(refId) {

            //var div = this.$refs[refId];
            var div = document.getElementById(refId);
            var width = div.clientWidth - 5;
            var height = 25;
            var svg = '<svg xmlns="http://www.w3.org/2000/svg" width="' + width + 3 + '" height="' + height + 3 + '" viewBox="0 0 ' + width + 3 + ' ' + height + 3 + '" preserveAspectRatio="none"><defs><style>.cls-1{fill: #fff;}.cls-1, .cls-2 {stroke: #00676c;stroke-width: 1px;}.cls-2 {fill: #00676c;}</style></defs><rect id="Rectangle_12_copie_2" data-name="Rectangle 12 copie 2" class="cls-1" x="3" y="3" width="' + width + '" height="' + height + '"/>  <rect id="Rectangle_12_copie_2-2" data-name="Rectangle 12 copie 2" class="cls-2" width="' + width + '" height="' + height + '"/></svg>';
            //var svg = '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"  width="320px" height="100px" viewBox="0 0 320 100" enable-background="new 0 0 320 100" xml:space="preserve"> <polygon class="mystar" fill="#'+green+'" points="134.973,14.204 143.295,31.066 161.903,33.77 148.438,46.896 151.617,65.43 134.973,56.679 118.329,65.43 121.507,46.896 108.042,33.77 126.65,31.066 "/><circle class="mycircle" fill="#'+red+'" cx="202.028" cy="58.342" r="12.26"/></svg>';		
            var encoded = window.btoa(svg);
            div.style.backgroundImage = "url(data:image/svg+xml;base64," + encoded + ")";
            div.style.backgroundSize = "100% 30px;";
            div.style.color = "white";
            //console.log("selectFilter modifying style ->" + refId + " width:" + width);
            return refId;
        },
        $selectFilterCat: function $selectFilterCat(refId) {

            //var div = this.$refs[refId];
            var div = document.getElementById(refId);
            var width = div.clientWidth - 5;
            var height = 25;
            var svg = '<svg xmlns="http://www.w3.org/2000/svg" width="' + width + 3 + '" height="' + height + 3 + '" viewBox="0 0 ' + width + 3 + ' ' + height + 3 + '" preserveAspectRatio="none"><defs><style>.cls-1{fill: #fff;}.cls-1, .cls-2 {stroke: #00676c;stroke-width: 1px;}.cls-2 {fill: #00676c;}</style></defs><rect id="Rectangle_12_copie_2" data-name="Rectangle 12 copie 2" class="cls-1" x="3" y="3" width="' + width + '" height="' + height + '"/>  <rect id="Rectangle_12_copie_2-2" data-name="Rectangle 12 copie 2" class="cls-2" width="' + width + '" height="' + height + '"/></svg>';
            //var svg = '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"  width="320px" height="100px" viewBox="0 0 320 100" enable-background="new 0 0 320 100" xml:space="preserve"> <polygon class="mystar" fill="#'+green+'" points="134.973,14.204 143.295,31.066 161.903,33.77 148.438,46.896 151.617,65.43 134.973,56.679 118.329,65.43 121.507,46.896 108.042,33.77 126.65,31.066 "/><circle class="mycircle" fill="#'+red+'" cx="202.028" cy="58.342" r="12.26"/></svg>';		
            var encoded = window.btoa(svg);
            div.style.backgroundImage = "url(data:image/svg+xml;base64," + encoded + ")";
            div.style.backgroundSize = "100% 30px;";
            div.style.color = "white";
            //console.log("selectFilter modifying style ->" + refId + " width:" + width);
            return refId;
        },
        $initBackToTopBtn: function $initBackToTopBtn() {
            //-- Remove button
            var btn = document.getElementById('back-to-top-container');
            btn.classList.remove('show');
            //-- Check scroll for the backToTop button
            document.getElementById('router-container').onscroll = function () {
                var scrollSize = document.getElementById('router-container').scrollTop;
                var btn = document.getElementById('back-to-top-container');
                //console.log(scrollSize);
                if (scrollSize > 50) btn.classList.add('show');else btn.classList.remove('show');
            };
        },
        $loadMore: function $loadMore(marge, callback) {
            //-- Check scroll for the backToTop button
            document.getElementById('router-container').addEventListener('scroll', function () {
                var scrollSize = document.getElementById('router-container').scrollTop + document.getElementById('router-container').offsetHeight + marge;
                var screenHeight = document.getElementById('router-container').scrollHeight;
                //console.log(scrollSize +" >= " +screenHeight);
                if (scrollSize >= screenHeight) {
                    callback();
                }
            });
        },
        $formatDateUs: function $formatDateUs(date) {
            var startingDate = new Date(date);
            if (startingDate == 'Invalid Date') return;
            return startingDate.getFullYear() + "-" + (startingDate.getMonth() + 1).toLocaleString(undefined, { minimumIntegerDigits: 2 }) + "-" + startingDate.getDate().toLocaleString(undefined, { minimumIntegerDigits: 2 });
        },
        $formatDateNews: function $formatDateNews(date) {
            var startingDate = new Date(date);
            if (startingDate == 'Invalid Date') return;
            return startingDate.getDate().toLocaleString(undefined, { minimumIntegerDigits: 2 }) + "." + (startingDate.getMonth() + 1).toLocaleString(undefined, { minimumIntegerDigits: 2 }) + "." + startingDate.getFullYear();
        },
        $formatDateTimeFr: function $formatDateTimeFr(date) {
            //-- date must be US YYYY/MM/DD HH:MM
            var startingDate = new Date(date);
            //-- Checking if date is not empty or bad formatting
            if (startingDate == 'Invalid Date') return;

            var month = startingDate.toLocaleString('fr-fr', { month: 'short' });
            var day = startingDate.toLocaleString('fr-fr', { weekday: 'short' });
            var dayInt = startingDate.getDate().toLocaleString(undefined, { minimumIntegerDigits: 2 });
            var hours = startingDate.getHours().toLocaleString(undefined, { minimumIntegerDigits: 2 });
            var minutes = startingDate.getMinutes().toLocaleString(undefined, { minimumIntegerDigits: 2 });

            return day + ' ' + dayInt + ' ' + month + ' ' + startingDate.getFullYear() + ' ' + hours + ':' + minutes;
        },
        $formatDateFr: function $formatDateFr(date) {
            var noWeekDay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var startingDate = new Date(date);
            //-- Checking if date is not empty or bad formatting
            if (startingDate == 'Invalid Date') return;

            var month = startingDate.toLocaleString("fr-fr", { month: "short" });
            var day = noWeekDay ? startingDate.toLocaleString("fr-fr", { weekday: "short" }) : '';
            return day + " " + startingDate.getDate().toLocaleString(undefined, { minimumIntegerDigits: 2 }) + " " + month + " " + startingDate.getFullYear();
        },
        $processExecMsg: function $processExecMsg(data) {
            if (!this.$checkNull(data)) this.$Notification.error(data.replace(/<[^>]+>/g, ''));else if (this.$checkNull(data.result)) {
                var code = data.result.code;
                var msg = data.result.msg;

                if (code == '100') {
                    this.$Notification.success('' + msg);
                    return true;
                } else this.$Notification.warn('' + msg);
            } else {
                //-- No return formated, displaying raw result | removing html
                this.$Notification.error(data.replace(/<[^>]+>/g, ''));
            }

            return false;
        },
        $test: function $test() {
            this.$Notification.warn("test");
        },
        $processDataMsg: function $processDataMsg(data) {
            if (this.$checkNull(data.code)) {
                //this.$Notification.warn(`Code: ${data.code} || Msg: ${data.msg}`)
                this.$Notification.warn('' + data.msg);
                return false;
            } else return true;
        },
        $formatBytes: function $formatBytes(bytes) {
            var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

            if (bytes === 0) return '0 Bytes';

            var k = 1024;
            var dm = decimals < 0 ? 0 : decimals;
            var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

            var i = Math.floor(Math.log(bytes) / Math.log(k));

            return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
        },
        $preloadImages: function $preloadImages(urls, allImagesLoadedCallback) {
            var _this = this;

            var loadedCounter = 0;
            var toBeLoadedNumber = urls.length;
            urls.forEach(function (url) {
                _this.$preloadImage(url, function () {
                    loadedCounter++;
                    //console.log('Number of loaded images: ' + loadedCounter);
                    if (loadedCounter == toBeLoadedNumber) {
                        allImagesLoadedCallback();
                    }
                });
            });
        },
        $preloadImage: function $preloadImage(url, anImageLoadedCallback) {
            var img = new Image();
            img.onload = anImageLoadedCallback;
            img.src = url;
        },
        $hexToRgb: function $hexToRgb(hex) {
            var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
            return result ? {
                r: parseInt(result[1], 16),
                g: parseInt(result[2], 16),
                b: parseInt(result[3], 16)
            } : null;
        },
        $existValueArrays: function $existValueArrays(tab1, tab2) {
            if (!Array.isArray(tab1)) return false;
            if (!Array.isArray(tab2)) tab2 = [tab2];
            var rs = false;
            if (this.$checkNull(tab1)) {
                for (var i = 0; i < tab1.length; i++) {
                    if (this.$checkNull(tab2)) tab2.forEach(function (item) {
                        if (tab1[i] == item) rs = true;
                    });
                    if (rs) return true;
                }
            }
        }
    }
});

/***/ }),

/***/ "TqbL":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/RaisonnePro-Regular.f18a60a.woff";

/***/ }),

/***/ "VYNO":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/RaisonnePro-Regular.3701af3.ttf";

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./src/config/env.js
var env = __webpack_require__("uaSg");

// EXTERNAL MODULE: ./src/store/index.js
var store = __webpack_require__("IcnI");

// CONCATENATED MODULE: ./src/router/routes.js



var routes = [{
    path: '/login',
    name: 'Login',
    component: function component(resolve) {
        return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(11)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("P7ry")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: { title: env["c" /* DOMAIN_TITLE */] + ' | Login', auth: false, front: false }
}, {
    path: '/admin/',
    component: function component(resolve) {
        return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(10)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("/wdL")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: { auth: true, front: false },
    children: [, {
        path: '/',
        redirect: 'dashboard'
    }, {
        path: 'dashboard',
        name: 'dashboard',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(9)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("hRx6")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: { title: env["c" /* DOMAIN_TITLE */] + ' | Dashboard', auth: true, front: false }
    }, {
        path: 'users',
        name: 'users',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(14)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("ABZ1")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: { title: env["c" /* DOMAIN_TITLE */] + ' | Utilisateurs', auth: true, front: false }
    }, {
        path: 'dyn-contents',
        name: 'dynContents',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(16)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("elGi")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: { title: env["c" /* DOMAIN_TITLE */] + ' | Contenus dynamiques', auth: true, front: false }
    }, {
        path: 'item/:newsType',
        name: 'news',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(13)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("rkAu")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: { title: env["c" /* DOMAIN_TITLE */] + ' | Contenu', auth: true, front: false }
    }, {
        path: 'project',
        name: 'project',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(5)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("SjE/")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: { title: env["c" /* DOMAIN_TITLE */] + ' | Contenu', auth: true, front: false }
    }, {
        path: 'upload',
        name: 'upload',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("iZ6l")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: { title: env["c" /* DOMAIN_TITLE */] + ' | Journal', auth: true, front: false }
    }]
}, {
    path: '/:lng',
    component: function component(resolve) {
        return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(1)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("eerB")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: { auth: false, front: true },
    children: [{
        path: '/',
        name: 'home',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(2)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("lgCm")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: { auth: false, front: true, menu: false }
    }, {
        path: 'studio',
        name: 'studio',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(8)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("nUib")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: { auth: false, front: true, menu: false }
    }, {
        path: 'newsroom',
        name: 'newsroom',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(6)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("n8NQ")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: { auth: false, front: true, menu: false }
    }, {
        path: 'projects',
        name: 'projects',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(4)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Ik1+")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: { auth: false, front: true, menu: false }
    }, {
        path: 'contact',
        name: 'contact',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(12)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("cB7w")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: { auth: false, front: true, menu: false }
    }, {
        path: 'project-details/:projectSlug',
        name: 'project-details',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(3)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("BfZ+")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        //props: true,
        meta: { auth: false, front: true, menu: false }
    }, {
        path: 'blog',
        name: 'blog',
        component: function component(resolve) {
            return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(7)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("cGe3")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: { auth: false, front: true, menu: false }
    }]
}, {
    path: '*',
    beforeEnter: function beforeEnter(to, from, next) {
        //console.log("erreur 404", store);
        //console.log(to);

        if (to.path == "/") {
            //this.push({ path: '/fr' });
            next({
                path: '/' + store["a" /* default */].getters.currentLng
            });
        } else next();
    },

    component: function component(resolve) {
        return __webpack_require__.e/* require */(15).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("c5Mg")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: { title: env["c" /* DOMAIN_TITLE */] + ' | Erreur 404' }
}];
// CONCATENATED MODULE: ./src/router/index.js




vue_esm["default"].use(vue_router_esm["a" /* default */]);

var router = new vue_router_esm["a" /* default */]({
    routes: routes,
    mode: 'history',
    //linkActiveClass: "active"    
    //linkActiveClass: 'has-current',
    hashbang: false
});
//router.mode ='html5';
//router.beforeEach(guardRoute);


/* harmony default export */ var src_router = __webpack_exports__["a"] = (router);

/***/ }),

/***/ "e0XP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nsYt":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI0LjEuMiwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkNhbHF1ZV8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIKCSB2aWV3Qm94PSIwIDAgNDIuNSA0MS4xIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA0Mi41IDQxLjE7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDojQjZBMDZCO30KPC9zdHlsZT4KPGc+Cgk8cGF0aCBjbGFzcz0ic3QwIiBkPSJNMS40LDIwLjVjMCwxLjEsMC45LDIsMiwyaDMxTDIxLjksMzVjLTAuOCwwLjgtMC44LDIsMCwyLjhjMC44LDAuOCwyLDAuOCwyLjgsMGwwLDBsMTUuOS0xNS45CgkJYzAuMS0wLjEsMC4yLTAuMiwwLjItMC4zdi0wLjFsMC4xLTAuM3YtMC4xYzAtMC4xLDAuMS0wLjIsMC4xLTAuM2MwLTAuMSwwLTAuMywwLTAuNGMwLTAuMSwwLTAuMywwLTAuNGMwLTAuMSwwLTAuMi0wLjEtMC4ydi0wLjEKCQlsLTAuMS0wLjN2LTAuMWwtMC4yLTAuM0wyNC44LDMuMmMtMC44LTAuOC0yLTAuOC0yLjgsMGMtMC44LDAuOC0wLjgsMiwwLDIuOGwxMi41LDEyLjVoLTMxQzIuMywxOC41LDEuNCwxOS40LDEuNCwyMC41eiIvPgo8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ "uaSg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DOMAIN_TITLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DOMAIN; });
/* unused harmony export WWW_IMAGE_PATH */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API_URL; });
var domain =  true ? window.location.protocol + "//" + window.location.hostname + "/index.php" : "https://as.wearenotalone.fr/index.php";
var DOMAIN_TITLE = 'Androlus Studio';
var DOMAIN = domain;
var WWW_IMAGE_PATH = domain + "/images/";
//export const DOMAIN = `http://www.androlusstudio.com/index.php`;
var API_URL = "" + DOMAIN;
// export const API_PORT = `5000`;
// export const API_URL = `${DOMAIN}:${API_PORT}`;

/***/ })

},["0Flw"]);


// WEBPACK FOOTER //
// static/js/app.46abbfeed54fd442a49f.js